import { neon } from '@neondatabase/serverless';

let DATABASE_URL = import.meta.env.VITE_DATABASE_URL || '';
DATABASE_URL = DATABASE_URL.replace(/[&?]channel_binding=require/g, '');
const sql = neon(DATABASE_URL);

async function hashPassword(password) {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

function generateToken() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
}

export const auth = {
  async login(email, password) {
    try {
      const passwordHash = await hashPassword(password);
      
      const result = await sql`
        SELECT id, email, name, is_active 
        FROM admin_users 
        WHERE email = ${email} AND password_hash = ${passwordHash} AND is_active = true
      `;

      if (result.length === 0) {
        throw new Error('Invalid email or password');
      }

      const user = result[0];
      
      // Create session in localStorage
      const session = {
        user,
        token: generateToken(),
        expiresAt: Date.now() + (24 * 60 * 60 * 1000) // 24 hours
      };

      localStorage.setItem('admin_session', JSON.stringify(session));
      
      return session;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  getSession() {
    try {
      const sessionData = localStorage.getItem('admin_session');
      if (!sessionData) return null;

      const session = JSON.parse(sessionData);
      
      // Check if session expired
      if (Date.now() > session.expiresAt) {
        this.logout();
        return null;
      }

      return session;
    } catch (error) {
      console.error('Get session error:', error);
      return null;
    }
  },

  logout() {
    localStorage.removeItem('admin_session');
  },

  isAuthenticated() {
    return this.getSession() !== null;
  }
};
